/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Status_Fetching_PageInputs */

const en_import_status_fetching_page = /** @type {(inputs: Import_Status_Fetching_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading the page…`)
};

const de_import_status_fetching_page = /** @type {(inputs: Import_Status_Fetching_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite wird gelesen…`)
};

/**
* | output |
* | --- |
* | "Reading the page…" |
*
* @param {Import_Status_Fetching_PageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_fetching_page = /** @type {((inputs?: Import_Status_Fetching_PageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_Fetching_PageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_fetching_page(inputs)
	return en_import_status_fetching_page(inputs)
});